'use strict';

var React = require('react'),
    createStoreMixin = require('../mixins/createStoreMixin'),
    ZineStore = require('../stores/ZineStore'),
    StampStore = require('../stores/StampStore'),
    Group = require('../organisms/Group'),
    SidebarBody = require('../organisms/SidebarBody'),
    pluralize = require('../utils/pluralize'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var StampOtherZines = React.createClass({
  mixins: [createStoreMixin(StampStore, ZineStore), PureRenderMixin],

  propTypes: {
    stampId: PropTypes.number.isRequired,
    zineSlugs: PropTypes.arrayOf(
      PropTypes.string.isRequired
    ).isRequired
  },

  getStateFromStores(props) {
    return {
      stamp: StampStore.get(props.stampId),
      zines: props.zineSlugs.map(ZineStore.get)
    };
  },

  render() {
    var title = 'This Stamp in Other Collections',
        subtitle = '“' + this.state.stamp.title + '” is also in ',
        zineCount = this.state.zines.length;

    subtitle += zineCount;
    subtitle += pluralize(zineCount, ' collection.', ' collections.');

    return (
      <SidebarBody title={title}
                   subtitle={subtitle}>
        <Group type='zines'
               context='sidebar'
               mode='grid'
               columns={2}
               items={this.state.zines}
               itemProps={{ size: 'small' }} />
      </SidebarBody>
    );
  }
});

module.exports = StampOtherZines;



/** WEBPACK FOOTER **
 ** ./sidebar/StampOtherZines.jsx
 **/